export default "__VITE_ASSET__8b8dd485__"